import {lazy} from 'react';

export const DynamicChartLazy = lazy(() => import(/* webpackChunkName: "dynamicChart" */ './dynamicChartInit'));
export const StaticPieChartLazy = lazy(() => import(/* webpackChunkName: "staticPieChart" */ './staticPieChart/staticChartInit'));
